import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.125 7C13.125 3.61726 10.3827 0.875001 7 0.875C3.61726 0.874998 0.875001 3.61725 0.875 7C0.874998 10.3827 3.61725 13.125 7 13.125C10.3827 13.125 13.125 10.3827 13.125 7ZM7.4375 3.50027V8.3125H6.5625V3.50027H7.4375ZM6.47 9.625H7.52V10.675H6.47V9.625Z"
      fill="white"
      fillOpacity="0.65"
    />
  </svg>
);
export default SVGComponent;
